/* eslint-disable jsx-a11y/label-has-associated-control */
import { Power } from 'react-feather';
import { CardText, CardTitle, Col, Row } from 'reactstrap';
import { useBrand } from '@hooks/useBrand';
import source from '@src/assets/images/pages/create-account.svg';
import logo from '@src/assets/images/logo/logo.png';
import { Link, Redirect, useHistory } from 'react-router-dom';
import api from '@src/services/api';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import useJwt from '@src/auth/jwt/useJwt';
import { handleLogout } from '@src/redux/actions/auth';
import { useEffect, useState } from 'react';
import './styles.scss';
import getIpV4 from '@src/services/hooks/getIpV4/useGetIpv4';
import { toastError, toastSuccess } from '@src/utility/Toast';
import { getHomeRouteForLoggedInUser } from '@src/utility/Utils';
import { useSignedTerms } from '@src/services/hooks/VerificationSigningTerms/useVerificationSigningTerms';
import { ConfirmSigningDialog } from './ConfirmSigningDialog';

export function SigningOfTerms() {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [currentAccount, setCurrentAccount] = useState(false);
  const { brand, nameTab } = useBrand();
  const handleClickLogout = async () => {
    await api.post('logout', null, {
      headers: {
        Authorization: `Bearer ${useJwt.getToken()}`,
      },
    });
    dispatch(handleLogout());
    queryClient.removeQueries();
    history.push('/login');
  };
  const handleClickSigned = async () => {
    if (isChecked) {
      const userData = localStorage.getItem('userData');
      const data = userData ? JSON.parse(userData) : null;
      const ipV4 = await getIpV4();
      const response = await api.put(
        'company/signing',
        { ip: ipV4 },
        {
          headers: {
            Authorization: `Bearer ${useJwt.getToken()}`,
          },
        }
      );
      toastSuccess({
        title: 'Parabéns',
        description: response.data.mensagem,
      });
      history.push(getHomeRouteForLoggedInUser(data.role));
    } else {
      toastError({
        title: 'Atenção',
        description: 'Para assinar clique no quadrado',
      });
    }
  };
  const handleCheckboxChange = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    setIsChecked(event.target.checked);
  };
  const handleCheckboxChangeCurrentAccount = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    setCurrentAccount(event.target.checked);
  };
  const userData = JSON.parse(localStorage.getItem('userData') ?? 'null');
  const token = localStorage.getItem('accessToken') || '';
  const { isLoading, data } = useSignedTerms(token);
  if (isLoading) {
    return null;
  }
  if (data.isSigned || userData.isTheSupport) {
    history.push(getHomeRouteForLoggedInUser(userData.role));
  }
  window.history.pushState(null, '', window.location.pathname);
  return (
    <div className="auth-wrapper auth-v2">
      <Row className="auth-inner m-0">
        <Col
          className="d-none d-lg-flex align-items-center p-0 position-relative"
          lg="3"
          sm="12"
        >
          <div className="w-100 d-lg-flex align-items-center justify-content-center">
            <img className="img-fluid w-100" src={source} alt="Login Cover" />
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <Link
              className="brand-logo position-absolute"
              style={{
                top: '10%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
              }}
              to="#"
            >
              {nameTab.toLowerCase() !== 'ultrapayments' ? (
                <img
                  src={brand}
                  alt={`Logo ${nameTab}`}
                  className="img-fluid"
                  style={{ width: '189px' }}
                />
              ) : (
                <img
                  src={logo}
                  alt="Logo Ultrapayments"
                  className="img-fluid"
                />
              )}
            </Link>
          </div>
        </Col>
        <Col
          className="auth-bg px-2 px-sm-3 px-lg-5 pt-3 mb-5 pb-3"
          lg="9"
          sm="12"
        >
          <Row className="justify-content-center">
            <Col className="d-flex flex-column justify-content-center align-items-center">
              <CardTitle className="mb-1" tag="h1">
                Assinatura de Termos
              </CardTitle>
              <CardText className="mb-2">
                A assinatura dos termos é necessária para continuar usando
                nossos serviços.
              </CardText>
            </Col>
          </Row>
          <div className="d-flex justify-content-end">
            <button
              style={{ bottom: 20, right: 20 }}
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => handleClickLogout()}
            >
              <Power size={14} className="mr-75" />
              <span className="align-middle">Sair</span>
            </button>
          </div>
          <hr style={{ paddingBottom: '30px' }} />
          <div className="checkbox-container d-flex justify-content-center align-items-center">
            <label className="custom-checkbox" htmlFor="custom-checkbox-1">
              <input
                id="custom-checkbox-1"
                type="checkbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
              />
              <span className="checkmark" />
            </label>
            <span className="spaced-text">estou de acordo com os</span>
            <a
              href="https://ultrapayments.com.br/termo-de-uso/ultrapayments-Contrato-de-Prestacao-de-Servicos-de-Credenciamento.pdf"
              className="spaced-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              termo de serviço
            </a>
            <span className="spaced-text">e a</span>
            <a
              href="https://ultrapayments.com.br/politica-privacidade/ultrapayments-Politica-de-Privacidade.pdf"
              className="spaced-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              politica de privacidade
            </a>
            <span className="spaced-text">da plataforma</span>
          </div>
          <div className="checkbox-container hidden">
            <label className="custom-checkbox" htmlFor="custom-checkbox-2">
              <input
                id="custom-checkbox-2"
                type="checkbox"
                checked={currentAccount}
                onChange={handleCheckboxChangeCurrentAccount}
              />
              <span className="checkmark" />
            </label>
            <span className="spaced-text">estou de acordo com os</span>
            <a
              href="https://u2pay.com.br/termosdeuso/u2pay-Contrato-de-Prestacao-de-Servicos-de-Credenciamento.pdf"
              className="spaced-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              termos da conta corrente
            </a>
          </div>
          <Row className="mt-4 justify-content-end">
            <Col sm="auto">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setIsOpen(true)}
                disabled={!isChecked}
              >
                Continuar
              </button>
            </Col>
          </Row>
        </Col>
      </Row>
      <ConfirmSigningDialog
        description={
          <div className="d-flex flex-column">
            <p className="m-0">
              Confirma a assinatura dos Termo de Uso e Politica de privacidade?
            </p>
            <small>Essa ação é irreversível</small>
          </div>
        }
        isOpen={isOpen}
        onClickAction={handleClickSigned}
        onToggle={() => setIsOpen(false)}
        title="Assinatura de Termos"
      />
    </div>
  );
}
